import {types} from './types';

const setGetKycAction = (payload) => {
    return {
        type: types.SET_LIST,
        payload,
      }
}

export {
  setGetKycAction
}